import { render, staticRenderFns } from "./CandidateInterviewForm.vue?vue&type=template&id=5b6c8a56&scoped=true"
import script from "./CandidateInterviewForm.vue?vue&type=script&lang=js"
export * from "./CandidateInterviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c8a56",
  null
  
)

export default component.exports